import { api } from "@ancademy/vse-client";
import { CityName, Md, showMsg, Style } from "@client";
import { css } from "@emotion/css";
import { Npc } from "@npc";
import { Checkbox, Modal } from "antd";
import React, { useEffect, useState } from "react";

export function Welcome({ done }: { done: () => void }) {
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [read, setRead] = useState(false);
  useEffect(() => {
    return () => Npc.setVisible(false);
  }, []);
  return (
    <Modal
      title="免责声明"
      {...Md.pageProps}
      visible={showDisclaimer}
      cancelButtonProps={{ hidden: true }}
      onOk={async () => {
        Npc.setVisible(true);
        setShowDisclaimer(false);
        const { username } = await api.getUser();
        await showMsg(
          `亲爱的【${username}】，欢迎来到本虚拟仿真实验，我将作为你的助手，导引你完成在虚拟世界中的学习。`,
          {
            okText: "好的",
          }
        );
        await showMsg(
          `你来到一个陌生的城市【${CityName.from}】中，希望开展新的生活。在这一过程中，你将面临一系列的搜寻任务，在这些任务中，逐渐了解搜寻市场的特点，完成对搜寻市场各种现象的学习。当你熟悉搜寻市场后，你将有机会成为一家公司的销售人员，并在搜寻市场中设置各种销售策略，争取更高的收益。`,
          {
            okText: "知道了",
          }
        );
        await showMsg("接下来就由我陪伴你在一系列的【市场搜寻任务】中进行体验和学习吧！", {
          okText: "开始",
        });
        done();
      }}
      okButtonProps={{ disabled: !read, className: Style.btnPrimarySm }}
      okText="开始实验"
    >
      {`在实验开始前，请您务必仔细阅读并透彻理解本声明。一旦开始实验，您的使用行为将被视为接受本声明全部内容的约束。
1. 本实验使用的场景均为生活中常见的市场搜寻场景，不会给实验参与者带来超过在计算机前模拟日常决策以外的风险；
2. 本实验所有数据均以匿名的方式存放，无法通过数据本身追溯实验参与人；
3. 本实验产生的匿名数据只能用于服务师生、改进教研，不会被用作任何商业用途；
4. 本实验讨价还价部分采用开放对话的方式，参与人在使用开放对话功能时应遵守法律法规、学校规章制度和实验室操作规程，发表言论不得违反法律法规、不得违背公序良俗、不得侵害学校和他人的合法权益；
5. 开放对话功能中的言论不代表本实验软件立场，参与人对其发表的言论承担全部责任。如参与人言论或行为对学校造成不利影响，学校将保留依法追究其法律责任的权利。
`
        .trim()
        .split("\n")
        .map((str) => (
          <p
            className={css`
              padding: 1rem;
              font-size: 1.5rem;
            `}
          >
            {str}
          </p>
        ))}
      <p style={{ textAlign: "center", userSelect: "none" }}>
        <Checkbox checked={read} onChange={() => setRead(!read)}>
          我已阅读并透彻理解本声明，同意接受本声明全部内容的约束。
        </Checkbox>
      </p>
    </Modal>
  );
}
